"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressBar = void 0;
var react_1 = __importDefault(require("react"));
var ProgressBar = function (_a) {
    var _b = _a.wrapperClassName, wrapperClassName = _b === void 0 ? 'tw-rounded-[5px] tw-bg-DIVIDER_GRAY tw-h-[7px]' : _b, data = _a.data, total = _a.total, id = _a.id;
    return (react_1.default.createElement("div", { className: "tw-flex tw-w-full " + wrapperClassName, "data-testid": "progress-bar-wrapper-" + id }, data === null || data === void 0 ? void 0 : data.map(function (_a, index) {
        var value = _a.value, className = _a.className;
        var width = (value / total) * 100 + "%";
        return (react_1.default.createElement("div", { className: className, style: { width: width }, key: index, "data-testid": "progress-bar-item-" + index + "-" + id }));
    })));
};
exports.ProgressBar = ProgressBar;
